import { createSlice } from "@reduxjs/toolkit";

export const languageReducer = createSlice({
  name: "languages",
  initialState: {
    //language: "EN",
    languages: [
      { code: "en", name: "En", dir: "ltr" },
      { code: "ar", name: "Ar", dir: "rtl" },
    ],
  },
  reducers: {
    setGlobalLanguage: (state, action) => {
      // state.users = action.payload;
      state.languages = action.payload;
    },
  },
});

export const { setGlobalLanguage } = languageReducer.actions;

//export type LanguageInfo
export default languageReducer.reducer;
